const state = {
    saved: {}
};

const mutations = {
    saveView(state, {key, scope, values}) {
        state.saved = {...state.saved, [key]: {scope, values}};
    },
    resetViews(state) {
        state.saved = {};
    }
};

export const view = {
    namespaced: true,
    state,
    mutations
};
